class TeacherState {
    public selectedId: string
}

export default TeacherState


// WEBPACK FOOTER //
// ./src/components/teacher/TeacherState.ts